var _desc, _defs, _path, _g, _rect, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocketIso(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "723px",
    height: "1101px",
    viewBox: "0 0 723 1101",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "14.4057934%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFEFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "47.2543708%",
    y1: "-32.9779984%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E0FB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.000109%",
    y1: "103.511073%",
    x2: "50.000109%",
    y2: "-0.504704281%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE8FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFBFD",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7AA8E9",
    stopOpacity: 0.303376311,
    offset: "53.0194257%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Scene-1",
    transform: "translate(-321.000000, -407.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(321.000000, 407.000000)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M312.065323,705 C307.620879,937.540541 265.565323,1012.60882 185.898657,930.204836 C106.23199,847.800853 97.7189693,897.170697 160.359594,1078.31437 L607.117407,1101 C634.835131,964.141348 640.095474,884.993411 622.898437,863.556188 C615.710295,854.595701 611.314526,925.366156 562.398657,962.183575 C521.38485,993.053363 488.964213,970.461627 485.5,962.183575 C463.077158,908.602158 448.37671,822.874299 441.398657,705",
    id: "Path-44",
    fill: "url(#linearGradient-1)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.134042,705 C331.253404,937.540541 303.995368,1012.60882 252.359932,930.204836 C200.724497,847.800853 195.206837,897.170697 235.806954,1078.31437 L525.370144,1101 C543.335207,964.141348 546.744665,884.993411 535.598517,863.556188 C530.939568,854.595701 528.090479,925.366156 496.385975,962.183575 C469.803141,993.053363 448.789915,970.461627 446.544607,962.183575 C432.011387,908.602158 422.483387,822.874299 417.960607,705",
    id: "Path-44",
    fill: "url(#linearGradient-2)",
    style: {
      mixBlendMode: "multiply"
    },
    transform: "translate(375.500000, 903.000000) scale(-1, 1) translate(-375.500000, -903.000000) "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-62",
    transform: "translate(65.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.788877,743.950171 L406.489557,694.313057 C430.810087,616.441451 445.593959,536.840134 450.629444,456.649137 C450.947355,451.346042 451.222215,446.112234 451.454025,440.947713 C456.885168,311.357447 421.723872,182.749453 349.206057,66.9596139 L311.931049,7 L306.069574,7 L268.784632,66.9596139 C196.270251,182.750173 161.112382,311.358131 166.546599,440.947713 C166.778408,446.112234 167.053269,451.346042 167.371179,456.649137 C172.416431,536.840929 187.210288,616.442256 211.540871,694.313057 L228.236427,743.948553 C239.903699,778.63508 272.414066,802 309.010246,802 L309.010246,802 C345.607028,802 378.118538,778.636301 389.788877,743.950171 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,186.011433 C393.441008,147.91626 375.19114,110.69099 354.354371,74.5477049 L311.404623,0 L304.652598,0 L261.70285,74.5477049 C240.844205,110.733095 222.575234,148.001506 207,186.140649 C273.102759,201.996866 342.924204,201.952202 409,186.011433 Z",
    id: "Path",
    fill: "#A8CCFE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(233.000000, 256.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.552053,84.1520555 C145.345938,121.009358 113.407581,148 76,148 C38.5924192,148 6.65406196,121.009358 0.447946527,84.1520555 C-2.70456219,55.2235941 10.9668562,27.0393569 35.6466823,11.5882958 C60.3265084,-3.86276527 91.6734916,-3.86276527 116.353318,11.5882958 C141.033144,27.0393569 154.704562,55.2235941 151.552053,84.1520555 L151.552053,84.1520555 Z",
    id: "Path",
    fill: "#418CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.955159,82.4587943 C133.762968,112.987037 107.156313,135.333333 76,135.333333 C44.8436873,135.333333 18.237032,112.987037 13.0448408,82.4587943 C10.3994803,58.4731911 21.7869481,35.0961322 42.3595683,22.2792948 C62.9321885,9.4624573 89.0678115,9.4624573 109.640432,22.2792948 C130.213052,35.0961322 141.60052,58.4731911 138.955159,82.4587943 Z",
    id: "Path",
    fill: "#A8CCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3379405,12.6677915 L12.6666667,76.305646 C12.7396195,78.4374558 12.9246587,80.5639598 13.2210186,82.6763561 C15.0998146,95.555278 21.1010037,107.480081 30.3267339,116.666667 L118.666667,28.3868263 C106.946509,18.1655972 91.8933049,12.5754964 76.3379405,12.6677915 L76.3379405,12.6677915 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.333333,48.2336491 C131.205223,43.6186869 128.518945,39.2857991 125.335471,35.3333333 L38,123.164637 C42.1389501,126.184643 46.6175465,128.702725 51.3429192,130.666667 L133.333333,48.2336491 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-53",
    transform: "translate(240.000000, 452.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.625729,70.5057762 C121.440356,101.386218 94.7550182,124 63.5,124 C32.2449818,124 5.55964388,101.386218 0.374271112,70.5057762 C-2.25973288,46.2684167 9.16309697,22.6545963 29.7837411,9.7091127 C50.4043853,-3.2363709 76.5956147,-3.2363709 97.2162589,9.7091127 C117.836903,22.6545963 129.259733,46.2684167 126.625729,70.5057762 L126.625729,70.5057762 Z",
    id: "Path",
    fill: "#418CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.989954,69.0716912 C111.660875,94.5938044 89.4771151,113.275676 63.5,113.275676 C37.5228849,113.275676 15.3391254,94.5938044 11.010046,69.0716912 C8.80443097,49.0193324 18.2989294,29.4757265 35.4517077,18.7606395 C52.604486,8.04555258 74.395514,8.04555258 91.5482923,18.7606395 C108.701071,29.4757265 118.195569,49.0193324 115.989954,69.0716912 Z",
    id: "Path",
    fill: "#A8CCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6930106,10.7252668 L10.6947368,64.0434692 C10.7554608,65.8295801 10.9094826,67.6112456 11.1561646,69.3810912 C12.7200244,80.1715392 17.7152545,90.1625902 25.3945068,97.8594595 L98.9263158,23.8952689 C89.1707688,15.3315364 76.640882,10.6479384 63.6930106,10.7252668 L63.6930106,10.7252668 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.626316,40.2851479 C109.850711,36.4239658 107.609393,32.7987857 104.953238,29.4918919 L32.0842105,102.977361 C35.5375756,105.504097 39.2743272,107.610891 43.2169785,109.254054 L111.626316,40.2851479 Z",
    id: "Path",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M217,673 C286.471029,707.666667 347.471029,707.666667 400,673",
    id: "Path-33",
    stroke: "#418CFF",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1371949,656.183058 L29.9880264,768.259013 C23.1044153,803.090447 45.7606018,836.907172 80.5920355,843.790783 C97.2659217,847.085983 114.566226,843.644197 128.709301,834.218156 L239,760.711895 L191.40469,537.708549 L183.058122,531 L93.1802361,593.447596 C71.8816342,608.245969 57.1653781,630.740188 52.1371949,656.183058 Z",
    id: "Path",
    fill: "#418CFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5597134,661.090367 L34.1098546,771.722424 C26.2373934,805.944483 47.597963,840.068834 81.8200222,847.941296 C98.1192935,851.690789 115.239548,848.867231 129.47159,840.08236 L247,767.536768 L191.144183,538 L99.9384569,601.397135 C79.5275788,615.584744 65.1323835,636.865637 59.5597134,661.090367 Z",
    id: "Path",
    fill: "#A8CCFE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.551173,656.230219 L583.675886,768.485895 C590.540878,803.317275 567.869641,837.118863 533.038261,843.983855 C516.349578,847.273064 499.037546,843.813583 484.894616,834.363262 L375,760.93156 L422.519908,537.714964 L430.853253,531 L520.595973,593.512344 C541.857708,608.322692 556.540603,630.807748 561.551173,656.230219 Z",
    id: "Path",
    fill: "#418CFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.402748,661.153712 L579.860404,771.936505 C587.729096,806.178294 566.349477,840.315582 532.107689,848.184274 C515.793839,851.933163 498.659795,849.101151 484.419928,840.30217 L367,767.747015 L422.857935,538 L514.062557,601.468425 C534.457326,615.66095 548.837994,636.937852 554.402748,661.153712 Z",
    id: "Path",
    fill: "#A8CCFE",
    fillRule: "nonzero"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.69,
    fill: "url(#linearGradient-4)",
    x: 360,
    y: 771,
    width: 31,
    height: 231
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(0.000000, 204.000000)",
    fill: "#418CFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.225553,248.356768 C628.225553,250.951135 626.257983,253.054285 623.830862,253.054285 C621.403741,253.054285 619.436171,250.951135 619.436171,248.356768 C619.436171,245.7624 621.403741,243.65925 623.830862,243.65925 C626.257983,243.65925 628.225553,245.7624 628.225553,248.356768 L628.225553,248.356768 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M722.766185,138.440065 C722.766178,140.341216 721.694124,142.054919 720.050446,142.781236 C718.406767,143.507553 716.515581,143.103263 715.259672,141.757083 C714.003762,140.410903 713.630782,138.388286 714.314834,136.633368 C714.998886,134.878449 716.605082,133.737281 718.383668,133.742547 C719.548096,133.742543 720.664655,134.237873 721.486888,135.119204 C722.30912,136.000536 722.76942,137.195404 722.766185,138.440065 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.830862,6.49317637 C623.835789,8.39432011 622.768186,10.111195 621.126399,10.8423832 C619.484612,11.5735715 617.592384,11.1748901 616.332986,9.83243911 C615.073587,8.48998814 614.69536,6.46848525 615.374855,4.71154522 C616.05435,2.95460519 617.657579,1.80867875 619.436171,1.80867146 C621.858546,1.80866153 623.824152,3.90389229 623.830862,6.49317637 L623.830862,6.49317637 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 602.100882,
    cy: 725.942043,
    rx: 4.39469073,
    ry: 4.69751743
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.161604,582.908493 C609.166533,583.930697 608.594262,584.855181 607.712161,585.250018 C606.830059,585.644854 605.812264,585.432099 605.134299,584.711152 C604.456334,583.990206 604.252037,582.903391 604.616857,581.958479 C604.981676,581.013566 605.843594,580.397092 606.799914,580.397078 C608.0995,580.39706 609.154905,581.519375 609.161604,582.908493 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.436314,453.342895 C529.429599,454.728195 528.37473,455.846062 527.078724,455.841283 C525.782718,455.836504 524.73509,454.710884 524.737317,453.325567 C524.739543,451.940251 525.790784,450.818486 527.086798,450.818467 C527.712043,450.818458 528.311504,451.084839 528.752475,451.558638 C529.193447,452.032438 529.439553,452.674575 529.436314,453.342895 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.799914,71.1653692 C606.793199,72.5506689 605.73833,73.6685359 604.442324,73.6637569 C603.146318,73.6589779 602.09869,72.5333579 602.100917,71.1480416 C602.103143,69.7627254 603.154384,68.6409601 604.450398,68.6409416 C605.075643,68.6409326 605.675104,68.9073128 606.116075,69.3811127 C606.557047,69.8549125 606.803153,70.4970488 606.799914,71.1653692 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.40317,458.365725 C617.408093,459.38911 616.834498,460.314413 615.950898,460.70848 C615.067297,461.102547 614.048547,460.887396 613.371545,460.163744 C612.694544,459.440092 612.493262,458.351142 612.861926,457.406655 C613.230589,456.462168 614.096242,455.849048 615.053654,455.85431 C615.676785,455.85431 616.274393,456.118905 616.715013,456.589887 C617.155633,457.060868 617.40317,457.699657 617.40317,458.365725 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 201.5,
    cy: 362.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3320543,704.499949 C97.3320476,706.399272 96.2752866,708.111326 94.6550554,708.836945 C93.0348242,709.562564 91.170616,709.158663 89.9326222,707.813777 C88.6946283,706.468892 88.3269687,704.44822 89.0012626,702.694989 C89.6755565,700.941758 91.25884,699.801687 93.0120543,699.806949 C94.1598717,699.806944 95.2605031,700.301798 96.0710061,701.182282 C96.8815091,702.062766 97.3352427,703.256485 97.3320543,704.499949 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4.5,
    cy: 353.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 161.5,
    cy: 181.5,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.316,11.5 C163.316,12.8856824 162.279091,14.009 161,14.009 C159.720909,14.009 158.684,12.8856824 158.684,11.5 C158.684,10.1143176 159.720909,8.991 161,8.991 C162.279091,8.991 163.316,10.1143176 163.316,11.5 Z",
    id: "Path"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIso);
export default __webpack_public_path__ + "static/media/rocket_iso.98971096148543ec72d6a2899bdf1906.svg";
export { ForwardRef as ReactComponent };